import React, { useState } from 'react';

interface PreviewModalProps {
    files: string[];
    onRemoveFile: (file: string, index: number) => void;
}

export function PreviewModal({ files, onRemoveFile }: PreviewModalProps) {
    const [_previewImage, setPreviewImage] = useState<string | null>(null);
    
    if (files.length === 0) return null;


    return (
        <div className="mx-[70px] flex flex-wrap text-neutral-400 max-w-[calc(100%-80px)]">
                {files.map((file, index) => (
                    <div key={index} className="rounded-md relative inline-block m-2.5">
                        <img 
                            src={file} 
                            alt={`file-preview-${index}`} 
                            className="rounded-md w-auto max-w-[75px] h-[60px] block object-cover cursor-pointer"
                            onClick={() => setPreviewImage(file)}
                        />
                        <button 
                            className="absolute -top-3 -right-3 w-6 h-6 bg-neutral-600 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer"
                            onClick={() => onRemoveFile(file, index)}
                            type="button"
                            aria-label="Remove file"
                        >
                            <i className="fas fa-times text-neutral-100 text-xs" />
                        </button>
                    </div>
                ))}
            </div>
    );
};

